<template>
  <el-row>
    <el-col>
      <h2>View & Change Pea Approvers</h2>
      <br/>
      <p><b>Note: Only PEA statuses that are Raised or Partially Approved may have approvers updated, added, or removed.  If a PEA No. is not in the list, review it's status.</b></p>
      <p><b>Note: Only approvers with a current status of Raised or Notification Pending may be updated or removed.</b></p>
      <el-dialog title="Add/Update Pea Approvers for a specific PEA"
        :visible.sync="addFormVisible">
        <p><b>Note: Only approvers with a current status of Raised or Notification Pending may be updated or removed.</b></p>
        <!--<p><b>Note: A new approval user role may need to be created if the specific approval user role is not listed.</b></p>-->
        <el-row :gutter="24">
          <el-col :lg="12">
            Pea No.: <el-input v-model="peaId" :disabled="true"></el-input>
          </el-col>
          <el-col :lg="12">
            Approval No.: <el-input v-model="authorizationData.id" :disabled="true"></el-input>
          </el-col>
        </el-row>
        <!--Pea No.: <el-input v-model="peaId" :disabled="true"></el-input>-->
        <br />
        <el-row :gutter="20">
          <el-col :lg="19">
            Current Approval User Role: <user-authorization-role-dropdown v-model="authorizationData.userAuthorizationRoleId" :inputModel="authorizationData.userAuthorizationRoleId" :disabled="true"></user-authorization-role-dropdown>
          </el-col>
          <!--<el-col :lg="1">
            <tool-tip-popup text="Note: A new approval user role may need to be created if the spcific approval user role is not listed"></tool-tip-popup>
          </el-col>-->
        </el-row>
        <br/>
        <el-row :gutter="20">
          <el-col :lg="19">
            Approver: <user-dropdown v-model="authorizationData.userId" :inputModel="authorizationData.userId" :disabled="this.approvedStatus" ></user-dropdown>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Select a different approver's name to change the approver.'"></tool-tip-popup>
          </el-col>
        </el-row>
        <!--Approval User Role: <user-authorization-role-dropdown v-model="authorizationData.userAuthorizationRoleId" :inputModel="authorizationData.userAuthorizationRoleId" :disabled="this.approvedStatus"></user-authorization-role-dropdown>-->
        <br />
        <el-row :gutter="20">
          <el-col :lg="12">
             Active:  <el-checkbox v-model="authorizationData.isActive" :disabled="this.approvedStatus"></el-checkbox>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: When unchecked, this approval is removed from the PEA and no longer active."></tool-tip-popup>
          </el-col>
        </el-row>
        <br />
        Approval Status: <all-status-dropdown v-model="authorizationData.approvalStatusId" :inputModel="authorizationData.approvalStatusId" :disabled="true"></all-status-dropdown>
        <br /><br />
        <button class="btn btn-success" @click="update()" :disabled="this.approvedStatus">Update Current Approval</button>
      </el-dialog>

      <el-row>
        <el-col>
          <!--View Approver List for a PEA No.: <el-input-number v-model="peaId" :min="0" :max="9999999999" :step="1" ></el-input-number>-->
          PEA No.:
          <el-input-number v-model="peaId" :min="0" :max="999999" :step="1" ></el-input-number>
          </el-col>
      </el-row>

      <br />
      <el-row>
        <el-col>
          <el-alert v-if="alertTitle !== ''"
            :title="alertTitle"
            :type="alertType"
            :description="callInfo"
            :closable="false"
            show-icon>
          </el-alert>
          <el-button class="btn btn-primary"  @click="search()">Show PEA Approvers</el-button>
          <el-button class="btn btn-success"  @click="showPopup()">Add PEA Approver</el-button>
          <el-button class="btn btn-primary" @click="setAsNextApprover()" :disabled="!this.showTable">Set Next Approver</el-button>
        </el-col>
      </el-row>
      <el-table ref="dataTable" v-if="showTable" :data="tableData" @row-click="selectRow" v-loading="tableLoading">
        <el-table-column align="left" style="word-wrap:normal"
          prop="authorizerName"
          label="Approver Name" sortable>
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
          prop="authorizationDivision"
          label="Division" sortable>
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
            prop="roleDescription"
            label="Approval Role" sortable>
        </el-table-column>
        <el-table-column align="left" style="word-wrap:normal"
            prop="approvalStatusName"
            label="Approval Status" sortable>
        </el-table-column>
      </el-table>
      <br/>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'adminViewPEAApproversByPEA',
  data () {
    return {
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      tableData: [{}],
      columns: Array,
      tableLoading: true,
      showTable: false,
      addFormVisible: false,
      peaId: '',
      userRoleId: 0,
      approvedStatus: false,
      authorizationId: 0,
      authorizationData: {
        id: 0,
        peaId: '',
        isActive: true,
        approvalStatusId: '',
        userAuthorizationRoleId: 0,
        userId: 0
      }
    }
  },
  methods: {
    showPopup () {
      if (this.peaId === 0 || this.peaId === '') {
        helperMethods.showNotification(this, 'Select a PEA No.', 'PEA No. Required', 'error', 15000)
      } else {
        this.authorizationData.peaId = this.peaId
        this.authorizationData.userAuthorizationRoleId = null
        this.authorizationData.isActive = true
        this.authorizationData.id = 0
        this.authorizationData.userId = 0
        // status id default is notification pending
        this.authorizationData.approvalStatusId = 14
        this.approvedStatus = false
        this.addFormVisible = true
      }
    },
    selectRow: function (row) {
      if (row !== null) {
        // this.peaId = row.peaId
        var call = '/getPEAAuthorizationById/' + row.id
        this.$axios.get(call).then(response => {
          this.authorizationData = response.data
          this.authorizationId = response.data.id
          // if approver status = notification pending or raised then allow editing
          if (response.data.approvalStatusId === 14 || response.data.approvalStatusId === 6) {
            this.approvedStatus = false
            //  this.addFormVisible = true
          } else {
            this.approvedStatus = true
            //  this.addFormVisible = false
          }
          this.addFormVisible = true
        })
      }
    },
    search () {
      this.alertTitle = ''
      if (this.$store.getters.isAdmin) {
        if (this.peaId === 0 || this.peaId === '') {
          helperMethods.showNotification(this, 'Select a PEA No.', 'PEA No. Required', 'error', 15000)
          this.showTable = false
          this.tableLoading = false
          this.tableData = null
          this.resultTotal = 0
        } else {
          this.showTable = true
          this.tableLoading = true
          var call = '/getPEAAuthorizations/' + this.peaId
          this.$axios.get(call).then(response => {
            this.tableData = response.data
            this.tableLoading = false
          }).catch(reject => {
            this.tableLoading = false
            this.tableData = null
            this.resultTotal = 0
            this.showTable = false
            helperMethods.showNotification(this, 'Error Retrieving PEA Authorizations', reject.body, 'error', 30000)
          })
        }
      }
    },
    update () {
      if (this.authorizationData.userId === 0 || this.authorizationData.userId === '' || this.authorizationData.userId === null) {
        helperMethods.showNotification(this, 'Select an Approver', 'Approver Required', 'error', 15000)
        this.addFormVisible = true
      } else {
        // can't send null down to API for a required integer so need to change it to 'updated by PEA Admin'
        if (this.authorizationData.userAuthorizationRoleId === null) {
          this.authorizationData.userAuthorizationRoleId = 9999
        }
        this.addFormVisible = false
        var call = '/updatePEAAuthorization/' + this.authorizationData.id
        return new Promise((resolve, reject) => {
          this.$axios.post(call, this.authorizationData).then(response => {
            this.isLoading = false
            this.search()
            helperMethods.showNotification(this, 'Successfully Added/Updated Approver ', 'Approver Added/Updated', 'success', 10000)
          })
            .catch(reject => {
              this.isLoading = false
              helperMethods.showNotification(this, 'Error adding/updating approver', reject.body, 'error', 30000)
            })
        })
      }
    },
    setAsNextApprover () {
      if (this.tableData.some(x => x.approvalStatusId === 6)) {
        helperMethods.showNotification(this, 'Approval already in raised status', 'Approval already raised', 'success', 15000)
      } else {
        var call = '/setPEANextApprover/' + this.peaId
        return new Promise((resolve, reject) => {
          this.$axios.post(call).then(response => {
            this.isLoading = false
            this.search()
            helperMethods.showNotification(this, 'Successfully Raised Next Approver', 'Approver raised and notified by email', 'success', 10000)
          })
            .catch(reject => {
              this.isLoading = false
              helperMethods.showNotification(this, 'Error Raising Approver', reject.body, 'error', 30000)
            })
        })
      }
    }
  }
}
</script>
